<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.licensePlateRecognition') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <i class="fa fa-car"></i>
          <span>{{ $ml.get('shared.licensePlateRecognition') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{ $ml.get('licensePlateRecognition.licensePlateList') }}</span>
              </h3>
              <div class="box-tools pull-right">
              </div>
            </div>
            <div class="box-body">
              <input type="text" :placeholder="$ml.get('general.search')" v-model="searchText" class="form-control"
                autocomplete="false" style="margin-bottom:10px;" />
              <div v-show="plateList.length > 0" class="table-responsive no-padding" :style="windowHeightSize">
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="plate in plateList" :key="plate.id">
                      <td>{{ plate.plate }}</td>
                      <td class="pull-right">
                        <button type="button" @click="selectPlate(plate)" class="btn btn-primary btn-sm">
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="plateList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{ $ml.get('licensePlateRecognition.plateNumberNotExist') }}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>{{ $ml.get('licensePlateRecognition.licensePlateInfo') }}</span>
              </h3>
              <div class="box-tools pull-right">
                <button v-show="authControl == 0" type="button" @click="newPlate()" class="btn btn-sm btn-warning ">{{
                  $ml.get('licensePlateRecognition.newLicensePlate') }}</button>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>{{ $ml.get('licensePlateRecognition.plateNumber') }}</label>
                      <input v-model="selectedPlate.plate" type="text" class="form-control" autocomplete="off" />
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>{{ $ml.get('licensePlateRecognition.employee') }}</label>
                      <div class="input-group">
                        <label v-text="getNameFromId(selectedPlate.employeeId)" class="form-control" />
                        <span class="input-group-btn">
                          <button data-toggle="modal" data-target="#modal-kisi-sec" type="button"
                            class="btn btn-primary">
                            <i class="fa fa-search"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>{{ $ml.get('licensePlateRecognition.deviceList') }}</label>
                      <div class="table-responsive">
                        <table class="table no-margin">
                          <tbody>
                            <tr v-for="reader in readers" :key="reader.readerId">
                              <th style="width:50px;">
                                <input type="checkbox" :id="'check' + reader.readerId" style="margin-right: 5px;"
                                  @change="reader.check = !reader.check" :checked="reader.check" />
                                <label :for="'check' + reader.readerId" class="input-text">{{ reader.name }}</label>
                              </th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="overlay" id="load" :hidden="!isLoading">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div class="box-footer">
                <div class="pull-right">
                  <button v-show="!isNewPlate && authControl == 0" type="button" data-toggle="modal"
                    data-target="#modal-sil" class="btn btn-sm btn-danger " style="margin: 5px; width:120px;">{{
                      $ml.get('general.delete') }}</button>
                  <button v-show="isNewPlate && authControl == 0" type="button" data-toggle="modal"
                    data-target="#modal-kaydet" class="btn btn-sm btn-success " style="margin: 5px; width:120px;">{{
                      $ml.get('general.save') }}</button>
                  <button v-show="!isNewPlate && authControl == 0" type="button" data-toggle="modal"
                    data-target="#modal-guncelle" class="btn btn-sm btn-success " style="margin: 5px; width:120px;">{{
                      $ml.get('general.update') }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.update') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.selectedPlate.plate }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('licensePlateRecognition.isContinueUpdateLicensePlate') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="savePlate()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.save') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{ this.selectedPlate.plate }}</p>
              <span>{{ $ml.get('licensePlateRecognition.isContinueSaveLicensePlate') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="savePlate()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{ $ml.get('general.save') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.delete') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.selectedPlate.plate }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('licensePlateRecognition.isContinueDeleteLicensePlate') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="deletePlate()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{ $ml.get('general.delete') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <div class="modal modal-xl fade" id="modal-kisi-sec">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('employees.selectEmployee') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12">
                  <input v-model="searchText2" class="form-control"
                    :placeholder="$ml.get('employees.searchFromNameSurname')" />
                </div>
                <div class="col-sm-12">
                  <div v-show="employeeList.length > 0" class="table-responsive no-padding"
                    style="max-height:500px;overflow:auto;">
                    <table class="table table-hover">
                      <tbody>
                        <tr>
                          <th>{{ $ml.get('employees.employeeList') }}</th>
                        </tr>
                        <tr v-for="employee3 in employeeList" :key="employee3.id">
                          <td>
                            {{ employee3.name }}
                            <span v-if="employee3.title != ''">- {{ employee3.title }}</span>
                          </td>
                          <button @click="selectedPlate.employeeId = employee3.id" data-dismiss="modal" type="button"
                            class="btn btn-primary btn-sm">
                            <i class="fa fa-check"></i>
                          </button>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-show="employeeList.length == 0" class="callout callout-info">
                    <i class="fa fa-info-circle"></i>
                    {{ $ml.get('employees.employeeSearchNotFound') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      searchText: "",
      searchText2: "",
      selectedPlate: {
        id: null,
        plate: "",
        accessPoints: [],
        employeeId: null
      },
      plates: [],
      employees: [],
      readers: [],
      isNewPlate: true
    };
  },
  computed: {
    authControl() {
      return this.$store.getters.getAuthAyarlar;
    },
    plateList() {
      if (this.searchText) {
        return this.plates.filter(item => {
          return this.searchText
            .toUpperCase()
            .split(" ")
            .every(v => item.plate.toUpperCase().includes(v))
        }).sort((a, b) => a.plate.localeCompare(b.plate));
      } else {
        return this.plates.sort((a, b) => a.plate.localeCompare(b.plate));
      }
    },
    employeeList() {
      if (this.searchText2) {
        return this.employees.filter(item => {
          return this.searchText2
            .toUpperCase()
            .split(" ")
            .every(v => item.name.toUpperCase().includes(v));
        });
      } else {
        return this.employees;
      }
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    getNameFromId(id) {
      let employee = this.employees.find(x => x.id == id);
      if (employee) {
        return employee.name + (employee.title != "" ? " - " + employee.title : "");
      } else {
        return "";
      }
    },
    selectPlate(plate) {
      this.isNewPlate = false;
      this.selectedPlate.id = plate.id;
      this.selectedPlate.plate = plate.plate;
      this.selectedPlate.accessPoints = plate.accessPoints;
      this.selectedPlate.employeeId = plate.employeeId;
      this.readers.forEach(reader => {
        if (reader.readerId == plate.accessPoints.find(x => x == reader.readerId)) {
          reader.check = true;
        } else {
          reader.check = false;
        }
      });
    },
    newPlate() {
      this.isNewPlate = true;
      this.selectedPlate.id = null;
      this.selectedPlate.plate = "";
      this.selectedPlate.accessPoints = [];
      this.selectedPlate.employeeId = null;
      this.readers.forEach(reader => {
        reader.check = false;
      });
    },
    async savePlate() {
      if (this.selectedPlate.plate == "") {
        alertify.warning(this.$ml.get("alerts.pleaseEnterAPlate"));
        return;
      }
      this.isLoading = true;
      var accessPoints = [];
      this.readers.forEach(reader => {
        if (reader.check == true) {
          accessPoints.push(reader.readerId);
        }
      });
      if (this.selectedPlate.id == null) {
        try {
          let selectedPlate2 = this.selectedPlate;
          await this.$axios
            .post("/Plate", {
              plate: selectedPlate2.plate,
              accessPoints: accessPoints,
              employeeId: selectedPlate2.employeeId
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
                this.getPlates();
                this.newPlate();
              } else {
                alertify.error(response.message);
              }
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          this.isLoading = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoading = false;
        }
      } else {
        //GÜNCELLE
        try {
          let selectedPlate2 = this.selectedPlate;
          const response = await this.$axios
            .put("/Plate/" + selectedPlate2.id, {
              plate: selectedPlate2.plate,
              accessPoints: accessPoints,
              employeeId: selectedPlate2.employeeId
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
                this.getPlates();
              } else {
                alertify.error(response.message);
              }
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          this.isLoading = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoading = false;
        }
      }
    },
    async deletePlate() {
      try {
        this.isLoading = true;
        let id = this.selectedPlate.id;
        const response = await this.$axios
          .delete("/Plate/" + id)
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
              this.getPlates();
              this.newPlate();
            } else {
              alertify.error(response.message);
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getPlates() {
      try {
        this.isLoading = true;
        var plates = [];
        const response = await this.$axios
          .get("/Plate")
          .then(response => {
            plates = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.plates = plates;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getReaders() {
      try {
        const readers = [];
        const response = await this.$axios
          .get("/Terminal/GetReaders")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                if (doc.doorType == 3) {
                  readers.push({
                    readerNo: doc.readerNo,
                    readerId: doc.readerId,
                    terminalId: doc.terminalId,
                    terminalNo: doc.terminalNo,
                    ipAddress: doc.ipAddress,
                    isActive: doc.isActive,
                    doorType: doc.doorType,
                    name: doc.name,
                    check: false
                  });
                }
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
              if (error.response.status == 500) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.readers = readers;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
      }
    },
    async getEmployees() {
      try {
        var employees = [];
        const response = await this.$axios
          .get("/Employees?every=false")
          .then(response => {
            if (response.status == 200) {
              employees = response.data;
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
              if (error.response.status == 500) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.employees = employees;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage")
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getReaders();
    await this.getEmployees();
    await this.getPlates();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/licensePlateRecognition/licensePlateRecognition.vue